import config from '../../config.json'

const menuItem = [
  {
    'key': 'my-profile',
    'label': 'My Profile',
    'icon': {
      'selected': '/icons/uc-profile.svg',
      'unselected': '/icons/profile.svg'
    },
    'url': '/profile',
    'display': true
  },
  {
    'key': 'my-vaccinations',
    'label': 'My vaccinations',
    'icon': {
      'selected': '/icons/uc-my-vaccinations.svg',
      'unselected': '/icons/my-vaccinations.svg'
    },
    'url': '/my-vaccinations',
    'display': true,
    'nodes': [
      {
        'key': 'dose-1',
        'label': 'Dose 1',
        'url': '/my-vaccinations/dose-1',
        'display': true
      },
      {
        'key': 'dose-2',
        'label': 'Dose 2',
        'url': '/my-vaccinations/dose-2',
        'display': true
      }
    ]
  },
  {
    'key': 'book-appointment',
    'label': 'Book appointment',
    'icon': {
      'selected': '/icons/uc-book-appointment.svg',
      'unselected': '/icons/book-appointment.svg'
    },
    'url': '/book-appointment',
    'display': true,
    'nodes': [
      {
        'key': 'Corporate Centers',
        'label': 'Corporate Centers',
        'url': '/book-appointment/corporate',
        'display': true
      },
      {
        'key': 'All Centers',
        'label': 'All Centers',
        'url': '/book-appointment/all-centers',
        'display': true
      }
    ]
  },
  {
    'key': 'my-appointment',
    'label': 'My appointments',
    'icon': {
      'selected': '/icons/uc-my-appointment.svg',
      'unselected': '/icons/my-appointment.svg'
    },
    'url': '/my-appointment',
    'display': true,
    'nodes': [
      {
        'key': 'Scheduled',
        'label': 'Scheduled',
        'url': '/my-appointment/scheduled',
        'display': true
      },
      {
        'key': 'completed',
        'label': 'Vaccination History',
        'url': '/my-appointment/completed',
        'display': true
      }
    ]
  },
  {
    'key': 'cowin-registration',
    'label': 'Co-WIN registration',
    'icon': {
      'selected': '/icons/Cowin_Portal.svg',
      'unselected': '/icons/Cowin_Portal.svg'
    },
    'url': 'https://selfregistration.cowin.gov.in',
    'display': true
  },
  {
    'key': 'cowin-certificate',
    'label': 'Co-WIN certificate',
    'icon': {
      'selected': '/icons/cowin-certificate.svg',
      'unselected': '/icons/cowin-certificate.svg'
    },
    'url': '/cowin-certificate',
    'display': false
  },
  {
    'key': 'vaccine-faqs',
    'label': 'Vaccine FAQs',
    'icon': {
      'selected': '/icons/uc-faq.svg',
      'unselected': '/icons/faq.svg'
    },
    'url': `${config.vaccine_faq}`,
    'display': true
  }
]

export default menuItem
